export default __webpack_public_path__ + "static/media/practice-mistakes.e853eb8d.svg";